import {
  Flex,
  Box,
  FormInput,
  IconButton,
  Button
} from '@sparrowengg/twigs-react';
import { DeleteIcon, PlusIcon } from '@sparrowengg/twigs-react-icons';
import { CustomHeaderProps } from 'features/apps/add-apps/types';
import { customFieldDefaultValue } from 'features/webhook/constants';

const CustomHeader = ({ fields, setFields }: CustomHeaderProps) => {
  const handleFieldInput = (value: string, id: number, property: string) => {
    setFields(
      fields.map((currentField) => {
        if (currentField.id === id) {
          return { ...currentField, [property]: value };
        } else {
          return currentField;
        }
      })
    );
  };

  return (
    <Flex flexDirection="column" gap="$6" css={{ marginTop: '$3' }}>
      {fields.map((field, idx) => (
        <Flex
          gap="$6"
          alignItems="center"
          css={{
            width: '100%',
            maxWidth: 400,
            position: 'relative',
            '&:hover': {
              '& button': {
                opacity: 1
              }
            }
          }}
          key={field.id}
        >
          <Box css={{ flex: 1 }}>
            <FormInput
              placeholder={'Key Name'}
              size="lg"
              onChange={(event) =>
                handleFieldInput(
                  event.currentTarget.value,
                  field.id,
                  'headerKey'
                )
              }
              value={field.headerKey}
            />
          </Box>
          <Box css={{ flex: 1 }}>
            <FormInput
              size="lg"
              placeholder="Value"
              value={field.headerValue}
              onChange={(event) =>
                handleFieldInput(
                  event.currentTarget.value,
                  field.id,
                  'headerValue'
                )
              }
            />
          </Box>
          {fields.length > 1 && (
            <IconButton
              css={{
                opacity: 0,
                transition: 'all .3s ease',
                minWidth: '$8',
                position: 'absolute',
                right: '-$22'  
              }}
              size="md"
              icon={<DeleteIcon />}
              variant="ghost"
              color="default"
              onClick={() =>
                setFields(
                  fields.filter((currentField) => currentField.id !== field.id)
                )
              }
            />
          )}
        </Flex>
      ))}

      <Button
        variant="ghost"
        rightIcon={<PlusIcon />}
        onClick={() =>
          setFields((prev) => [
            ...prev,
            {
              ...customFieldDefaultValue,
              id: prev.length ? prev[prev.length - 1]?.id + 1 : 1
            }
          ])
        }
        css={{ alignSelf: 'flex-start' }}
      >
        New Header
      </Button>
    </Flex>
  );
};

export default CustomHeader;
